// extracted by mini-css-extract-plugin
module.exports = {"errorText":"ErrorHandler_errorText__2MEC8"};